import { z } from 'zod'

export function getPaginationDataSchema<T extends z.ZodTypeAny>(data: T) {
  return z.object({
    items: z.array(data),
    pageSize: z.number(),
    pageNumber: z.number(),
    totalCount: z.number(),
  })
}
